import { defineComponent as _defineComponent } from 'vue';
import { defaultDocument, useEventListener, useMediaQuery, useVModel } from "@vueuse/core";
import { TooltipProvider } from "reka-ui";
import { computed, ref } from "vue";
import { cn } from '../../primitives/utils';
import { provideSidebarContext, SIDEBAR_COOKIE_MAX_AGE, SIDEBAR_COOKIE_NAME, SIDEBAR_KEYBOARD_SHORTCUT, SIDEBAR_WIDTH, SIDEBAR_WIDTH_ICON } from "./utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SidebarProvider',
    props: {
        defaultOpen: { type: Boolean, required: false, default: !defaultDocument?.cookie.includes(`${SIDEBAR_COOKIE_NAME}=false`) },
        open: { type: Boolean, required: false, default: undefined },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    emits: ["update:open"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emits = __emit;
        const isMobile = useMediaQuery("(max-width: 768px)");
        const openMobile = ref(false);
        const open = useVModel(props, "open", emits, {
            defaultValue: props.defaultOpen ?? false,
            passive: (props.open === undefined),
        });
        function setOpen(value) {
            open.value = value; // emits('update:open', value)
            // This sets the cookie to keep the sidebar state.
            document.cookie = `${SIDEBAR_COOKIE_NAME}=${open.value}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`;
        }
        function setOpenMobile(value) {
            openMobile.value = value;
        }
        // Helper to toggle the sidebar.
        function toggleSidebar() {
            return isMobile.value ? setOpenMobile(!openMobile.value) : setOpen(!open.value);
        }
        useEventListener("keydown", (event) => {
            if (event.key === SIDEBAR_KEYBOARD_SHORTCUT && (event.metaKey || event.ctrlKey)) {
                event.preventDefault();
                toggleSidebar();
            }
        });
        // We add a state so that we can do data-state="expanded" or "collapsed".
        // This makes it easier to style the sidebar with Tailwind classes.
        const state = computed(() => open.value ? "expanded" : "collapsed");
        provideSidebarContext({
            state,
            open,
            setOpen,
            isMobile,
            openMobile,
            setOpenMobile,
            toggleSidebar,
        });
        const __returned__ = { props, emits, isMobile, openMobile, open, setOpen, setOpenMobile, toggleSidebar, state, get TooltipProvider() { return TooltipProvider; }, get cn() { return cn; }, get SIDEBAR_WIDTH() { return SIDEBAR_WIDTH; }, get SIDEBAR_WIDTH_ICON() { return SIDEBAR_WIDTH_ICON; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
